import Tooltip from '@mui/material/Tooltip';
import { Ellipsis } from './ui/Ellipsis';
import { trim } from 'utils/string';
import useResizeAware from 'react-resize-aware';

type Props = {
  css?: string;
  name: string;
  conditionalTooltip?: boolean;
  customEllipsisCss?: unknown | null;
  ['data-testid']?: string;
  variant?: 'default' | 'noWrap';
};

const TextWithTooltip = ({
  name,
  conditionalTooltip = false,
  customEllipsisCss = null,
  'data-testid': dataTestid,
  variant = 'default',
}: Props): React.ReactElement => {
  // @ts-expect-error [EN-10263] - TS7006 - Parameter 'target' implicitly has an 'any' type.
  const [resizeListener, sizes] = useResizeAware((target) => ({
    clientWidth: target?.parentElement?.clientWidth ?? 0,
    scrollWidth: target?.parentElement?.scrollWidth ?? 0,
  }));

  const isOverflowing =
    sizes != null
      ? (sizes as unknown as { scrollWidth: number; clientWidth: number }).scrollWidth >
        (sizes as unknown as { scrollWidth: number; clientWidth: number }).clientWidth
      : false;
  return (
    <Ellipsis
      data-privacy
      css={{
        minWidth: 0,
        display: 'inline-block',
        padding: 0,
        position: 'relative',
        ...(customEllipsisCss as React.CSSProperties),
      }}
      data-testid={dataTestid}
      data-value={trim(name)}
    >
      {resizeListener}
      {variant === 'default' ? (
        <Tooltip title={name} disableHoverListener={conditionalTooltip === true && !isOverflowing}>
          <span>{name}</span>
        </Tooltip>
      ) : variant === 'noWrap' ? (
        <Tooltip
          title={name}
          disableHoverListener={conditionalTooltip === true && !isOverflowing}
          slotProps={{
            tooltip: {
              sx: {
                maxWidth: 'none',
              },
            },
          }}
        >
          <span>{name}</span>
        </Tooltip>
      ) : null}
    </Ellipsis>
  );
};

export default TextWithTooltip;
